import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { iepaProd } from "../../constants/global";

const CollectionSummary = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [rows, setRows] = useState([
    {
      id: 1,
      receivedBy: "Suresh",
      date: new Date().toISOString().split("T")[0],
      instrumentType: "Payment Mode",
      instrumentAmount: 10000,
      acceptedBy: "Jana",
      closureDate: new Date().toISOString().split("T")[0],
      status: "OPEN",
      receivedFrom: "Vijay",
    },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
           `${iepaProd.iepaCollectionSrvAPI}/collection/interface/crn/Sk-250709-064206/org/1`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
  
        const data = await response.json();
  
        // Optional: Map data to add `id` if not already present
        const rowsWithId = data.map((item, index) => ({
          ...item,
          id: item.id || index + 1, // Ensure DataGrid has a unique ID
        }));
  
        setRows(rowsWithId);
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("Failed to load collection summary.");
      }
    };
  
    fetchData();
  }, []);


  const handleChange = (id, field, value) => {
    const updatedRows = rows.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };

  const columns = [
    { field: "id", headerName: "ID (Primary)", flex: 0.5 },
    {
      field: "receivedBy",
      headerName: "Received By",
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.receivedBy}
          onChange={(e) =>
            handleChange(params.row.id, "receivedBy", e.target.value)
          }
          fullWidth
        />
      ),
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="date"
          value={params.row.date}
          onChange={(e) =>
            handleChange(params.row.id, "date", e.target.value)
          }
          fullWidth
        />
      ),
    },
    {
        field: "instrumentType",
        headerName: "Instrument Type",
        flex: 1,
        renderCell: (params) => (
          <Select
            value={params.row.instrumentType}
            onChange={(e) =>
              handleChange(params.row.id, "instrumentType", e.target.value)
            }
            fullWidth
          >
            <MenuItem value="Cash">Cash</MenuItem>
            <MenuItem value="Card">Card</MenuItem>
          </Select>
        ),
      },
    {
      field: "instrumentAmount",
      headerName: "Instrument Amount",
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.row.instrumentAmount}
          onChange={(e) =>
            handleChange(params.row.id, "instrumentAmount", e.target.value)
          }
          fullWidth
        />
      ),
    },
    {
      field: "acceptedBy",
      headerName: "Accepted By",
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.acceptedBy}
          onChange={(e) =>
            handleChange(params.row.id, "acceptedBy", e.target.value)
          }
          fullWidth
        />
      ),
    },
    {
      field: "closureDate",
      headerName: "Closure Date",
      flex: 1,
      renderCell: (params) => (
        <TextField
          type="date"
          value={params.row.closureDate}
          onChange={(e) =>
            handleChange(params.row.id, "closureDate", e.target.value)
          }
          fullWidth
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Select
          value={params.row.status}
          onChange={(e) =>
            handleChange(params.row.id, "status", e.target.value)
          }
          fullWidth
        >
          <MenuItem value="OPEN">OPEN</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Closed">Closed</MenuItem>
        </Select>
      ),
    },
    {
      field: "receivedFrom",
      headerName: "Received From",
      flex: 1,
      renderCell: (params) => (
        <TextField
          value={params.row.receivedFrom}
          onChange={(e) =>
            handleChange(params.row.id, "receivedFrom", e.target.value)
          }
          fullWidth
        />
      ),
    },
  ];

  return (
    <Box m="20px">
      <Typography variant="h4" mb={2}>
        Collection Summary
      </Typography>
      <Box
        sx={{
          height: "50vh",
          backgroundColor: colors.primary[400],
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          disableSelectionOnClick
        />
      </Box>
    </Box>
  );
};

export default CollectionSummary;